module.exports = __webpack_public_path__ + "static/img/map4.1413bfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map4.jpg
// module id = Tl0B
// module chunks = 1